import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class HistoriaDeLaColla extends Component {
	render() {
		const imageSizes_3d8f_StAlbert = [
			{ size: '576', url: 'images/resized/3d8f-sant-albert-576_x_323.jpg' },
			{ size: '768', url: 'images/resized/3d8f-sant-albert-768_x_431.jpg' },
			{ size: '992', url: 'images/resized/3d8f-sant-albert-992_x_557.jpg' },
			{ size: '1200', url: 'images/resized/3d8f-sant-albert-1200_x_674.jpg' },
			{ size: '1920', url: 'images/resized/3d8f-sant-albert-1920_x_1079.jpg' },
			{ size: 'max', url: 'images/3d8f-sant-albert.jpg' },
		];

		const imageSizes_Pd7fm_Aniversari = [
			{ size: '576', url: 'images/resized/pd7fm-construccio-2022-576_x_383.jpg' },
			{ size: '768', url: 'images/resized/pd7fm-construccio-2022-768_x_512.jpg' },
			{ size: '992', url: 'images/resized/pd7fm-construccio-2022-992_x_661.jpg' },
			{ size: '1200', url: 'images/pd7fm-construccio-2022.jpg' },
			{ size: '1920', url: 'images/pd7fm-construccio-2022.jpg' },
			{ size: 'max', url: 'images/pd7fm-construccio-2022.jpg' },
		];

		const imageSizes_3d8f_Aniversari = [
			{ size: '576', url: 'images/resized/3d8f-sentiment-2022-576_x_418.jpg' },
			{ size: '768', url: 'images/resized/3d8f-sentiment-2022-768_x_557.jpg' },
			{ size: '992', url: 'images/resized/3d8f-sentiment-2022-992_x_720.jpg' },
			{ size: '1200', url: 'images/resized/3d8f-sentiment-2022-1200_x_871.jpg' },
			{ size: '1920', url: 'images/resized/3d8f-sentiment-2022-1920_x_1394.jpg' },
			{ size: 'max', url: 'images/3d8f-sentiment-2022.jpg' },
		];

		return (<>
			<section className="historia">
				<h1 className="page-title">Història de la colla</h1>

				<h5>Els inicis</h5>
				<p>
					Fundats a la primavera de 1995, els Arreplegats de la Zona Universitària vam ser la segona colla castellera universitària en aparèixer. Ja des del primer moment vam apostar per només castells complets, sempre amb acotxador i enxaneta. El mateix maig del 1995 es va carregar el primer pilar de quatre, i a inicis de l'any següent van arribar els primers castells de sis: 4 de 6 descarregat i 3 de 6 carregat.
				</p>
				<p>
					El 1997 es va fer el primer viatge a Perpinyà, on finalment vam descarregar el primer 3 de 6 de la colla. Era un bon presagi, perquè l'objectiu de la temporada era el 5 de 6, que vam descarregar a la Diada el maig d'aquell mateix any, junt amb el primer pilar de 5 carregat.
				</p>
				<p>
					La temporada següent, vam experimentar un avenç brutal, carregant i després descarregant la primera torre de 6, descarregant el tres de 6 per sota, i acabant l'èxtasi amb el primer 4 de 7 carregat. Provar un castell de 7 pisos era un salt al desconegut, una nova dimensió en el món casteller universitari. Aquell any també es va descarregar el primer pilar de 5, i es va aconseguir carregar del 3 de 6 net carregat, que obria les portes al 3 de 7.
				</p>
				<p>
					Aquest castell, el 3 de 7, es va fer esperar més, sent el primer descarregat al final de la temporada 2000-2001. El següent any, es va carregar el primer 4 de 7 amb l'agulla, descarregat un any després. La temporada 2003-2004 va acabar amb dos nous castells: el <NavLink to="/castells/5d7/">5 de 7</NavLink> i la torre de 7 amb folre, ambdós descarregats. El següent castell amb folre va arribar durant la temporada 2006-2007, quan vam carregar el primer pilar de 6 amb folre de la història castellera universitària. Aquest castell finalment es va descarregar a les acaballes de la temporada 2007-2008, en la Diada de Primavera dels Ganàpies de l'Autònoma.
				</p>
			</section>
			{
				imageSizes_3d8f_StAlbert.map((img, i) => (
					<section key={`resized-3d8f-${i}`} className={`image-divider resized-img img-${img.size}`} style={{backgroundImage: `url('${img.url}')`}}></section>
				))
			}
			<section className="historia">
				<h5>Els únics que ho poden fer</h5>
				<p>
					La temporada 2008-2009 va estar marcada pel domini absolut de la gamma de castells de set i de set i mig, duts a diverses places. Aquest alt nivell va permetre a la colla assolir a finals de temporada l'èxit més sonat, descarregant en la mateixa actuació dos castells universitaris inèdits: el <NavLink to="/castells/3d7s/">3 de 7 per sota</NavLink> i el <NavLink to="/castells/4d8/">4 de 8</NavLink>. Aquest últim es va convertir en el primer castell de vuit pisos fet mai per una colla castellera universitària.
				</p>
				<p>
					La gran revolució va venir el 2010, quan ens atrevíem a portar a plaça les primeres manilles universitàries de la mà del <NavLink to="/castells/Pd7fm/">pilar de 7 amb folre i manilles</NavLink>. El vam haver de deixar en carregat, però no ens vam rendir, i el maig del 2013 el descarregàvem finalment.
				</p>
				<p>
					No gaire més tard, l'hivern del 2014, vam portar a la Diada dels Ganàpies de la UAB el primer <NavLink to="/castells/3d8f/">3 de 8 amb folre</NavLink> del món universitari, que veia com es feia història un altre cop en descarregar aquest castell fins aleshores inèdit. Aquell mateix desembre, pel nostre 19è Aniversari, sorpreníem el món sencer obrint plaça amb el <NavLink to="/castells/Vd6f/">vano de 6</NavLink>.
				</p>
			</section>
			{
				imageSizes_Pd7fm_Aniversari.map((img, i) => (
					<section key={`resized-Pd7fm-${i}`} className={`image-divider resized-img img-${img.size}`} style={{backgroundImage: `url('${img.url}')`}}></section>
				))
			}
			<section className="historia">
				<h5>L'època d'or</h5>
				<p>
					La següent temporada els Arreplegats vam seguir escrivint la història dels castells. El maig de 2015, en la nostra 20a Diada, vam descarregar el primer <NavLink to="/castells/9d7/">9 de 7</NavLink> universitari que mai ningú ha tornat a intentar.
				</p>
				<p>
					Aquests anys vam dominar tots els grans castells. Podíem fer, amb relativa facilitat, els castells més complicats del món casteller universitari, castells que ningú ha pogut igualar encara. Vam passejar per tot arreu els ja esmentats <NavLink to="/castells/3d8f/">3 de 8 amb folre</NavLink>, <NavLink to="/castells/3d7s/">3 de 7 per sota</NavLink>, <NavLink to="/castells/5d7/">5 de 7</NavLink>, i <NavLink to="/castells/4d8/">4 de 8</NavLink> demostrant el nostre domini per totes les places on passàvem.
				</p>
				<p>
					Aquesta època gloriosa va assolir el seu punt més àlgid el 5 de maig del 2016, on vam ajuntar el <NavLink to="/castells/3d8f/">3 de 8 amb folre</NavLink>, el <NavLink to="/castells/4d8/">4 de 8</NavLink>, i vam carregar la inèdita <NavLink to="/castells/Td8fm/">torre de 8 amb folre i manilles</NavLink> en una diada històrica.
				</p>
			</section>
			{
				imageSizes_3d8f_Aniversari.map((img, i) => (
					<section key={`resized-Pd7fm-${i}`} className={`image-divider resized-img img-${img.size}`} style={{backgroundImage: `url('${img.url}')`}}></section>
				))
			}
			<section className="historia">
				<h5>Represa després de la COVID-19</h5>
				<p>
					En reprendre l'activitat castellera després del confinament, hi havia molta feina a fer. Renovació, formació, recaptació de nous castellers, etc. Va ser un procés llarg, però no per això el vam encarar amb menys il·lusió.
				</p>
				<p>
					La diada més important des d'aleshores ha estat el nostre 27è Aniversari, el 22 de desembre de 2022. Després d'una gran temporada amb molta formació, vam poder conrear els fruits de tota la feina feta, i vam fer-hi el primer <NavLink to="/castells/5d7/">5 de 7</NavLink> universitari post-COVID, el primer <NavLink to="/castells/3d8f/">3 de 8 amb folre</NavLink> universitari post-COVID, la nostra quarta torre de 7 amb folre de la temporada, i hi vam carregar el <NavLink to="/castells/Pd7fm/">pilar de 7 amb folre i manilles</NavLink>. Aquest pilar no només representava les primeres manilles universitàries post-COVID, sinó que també ens va convertir en la sisena colla global en fer unes manilles després de la pandèmia.
				</p>
			</section>
		</>);
	}
}

export default HistoriaDeLaColla;
